import { render, staticRenderFns } from "./SMSService.vue?vue&type=template&id=512ebd48&scoped=true&"
import script from "./SMSService.vue?vue&type=script&lang=js&"
export * from "./SMSService.vue?vue&type=script&lang=js&"
import style0 from "./SMSService.vue?vue&type=style&index=0&id=512ebd48&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ebd48",
  null
  
)

export default component.exports